import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { getLettersToReview, Letter } from "../../../apis/Admin";
import ModalTree from "../../admin/ModalTree";
import Button from "../../atoms/Button";
import LetterCard from "../../atoms/LetterCard";

const LettersPage = () => {
  const [letters, setLetters] = useState<Letter[]>([]);
  const [showDetail, setShowDetail] = useState<
    | {
        userId: string;
        user: {
          name: string;
          lastname: string;
        };
        location: {
          courseId: string;
          episodeId: string;
          chapterId: string;
          lessonId: string;
        };
      }
    | undefined
  >(undefined);

  useEffect(() => {
    const unsubscribe = getLettersToReview((data) => setLetters(data));
    return () => unsubscribe();
  }, []);

  return (
    <>
      <Container>
        <List>
          {letters.length === 0 && <Label>No hay cartas para revisar.</Label>}
          {letters.map((letter) => (
            <LetterCard
              key={letter.id}
              name={letter.user.name}
              lastname={letter.user.lastname}
              date={letter.updatedAt}
              actions={
                <Button
                  type="primary-inverted"
                  icon="edit"
                  onClick={() => {
                    setShowDetail({
                      userId: letter.userId,
                      user: {
                        name: letter.user.name,
                        lastname: letter.user.lastname,
                      },
                      location: {
                        courseId: letter.location.courseId,
                        episodeId: letter.location.episodeId,
                        chapterId: letter.location.chapterId,
                        lessonId: letter.location.lessonId,
                      },
                    });
                  }}
                />
              }
            />
          ))}
        </List>
      </Container>
      {showDetail !== undefined && (
        <ModalTree
          userId={showDetail.userId}
          userName={showDetail.user.name}
          userLastname={showDetail.user.lastname}
          onClose={() => setShowDetail(undefined)}
          courseId={showDetail.location.courseId}
          episodeId={showDetail.location.episodeId}
          chapterId={showDetail.location.chapterId}
          lessonId={showDetail.location.lessonId}
        />
      )}
    </>
  );
};

const Container = styled.div``;

const List = styled.div`
  & > *:not(:last-child) {
    margin-bottom: ${8 * 2}px;
  }
`;

const Label = styled.div`
  text-align: center;
`;

export default LettersPage;
